import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../utils/GeneralUtils';
import './SwitchUiObject.scss';
import UiObjectUtils from './UiObjectUtils';
import { OrderPageData } from '../../api';
import { customerFacingPriceFormatter } from '../utils';
import { withBookingFee } from '../core/pricing';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { OrderPageCheckbox } from '../themedComponents/OrderPageCheckbox';

type SwitchUiObjectProps = {
  uiObject: any; // UIObjectData is not properly extracted from api as it has classes
  orderState: any;
  setCustomOrderDetailValue: any;
};
const SwitchUiObject = ({ uiObject, orderState, setCustomOrderDetailValue }: SwitchUiObjectProps) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const orderPage = orderState.orderPage as OrderPageData;
  const getDefaultValue = () => {
    if (uiObject.data_type === 'custom' && orderState.details && orderState.details.custom_details) {
      return orderState.details.custom_details[uiObject.name];
    }
    return false;
  };

  const [checked, setChecked] = useState(getDefaultValue());
  const handleChange = (event: any) => {
    setChecked(event.target.checked);
    setCustomOrderDetailValue(uiObject.name, event.target.checked);
  };

  if (!UiObjectUtils.getConditionResult(uiObject.condition, orderState)) {
    return null;
  }
  // @ts-ignore
  const priceObj = orderPage.price.find((x) => x.name === uiObject.name)?.price;
  const priceIsPerPerson = priceObj.price_per_additional_value > 0;

  return (
    <div className="switch-ui-object ">
      <Grid container flexDirection="row" wrap="nowrap" alignItems="flex-start">
        <OrderPageCheckbox
          checked={checked}
          onChange={handleChange}
          sx={{
            paddingTop: '4px',
            paddingInlineStart: '0px',
          }}
        />
        <Grid item container flexDirection="column">
          <Grid item container alignItems="flex-end" gap={0.5}>
            <OrderPageTypography variant="h6">{uiObject.label[language]}</OrderPageTypography>
            {uiObject.link_to_details && (
              <a className="link" target="_blank" href={uiObject.link_to_details} rel="noreferrer">
                <OrderPageTypography variant="body2" style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                  {t('uiObjects.includes')}
                </OrderPageTypography>
              </a>
            )}
          </Grid>
          <Grid item container gap={0.5}>
            <OrderPageTypography variant="body1" style={{ opacity: 0.7, fontWeight: 400 }}>
              {t('uiObjects.additional')}{' '}
              {customerFacingPriceFormatter(
                withBookingFee(priceObj.base_price, orderState.account),
                orderState.account,
              )}
            </OrderPageTypography>
            <OrderPageTypography variant="body1" style={{ opacity: 0.7, fontWeight: 400 }}>
              {priceIsPerPerson ? t('uiObjects.perPerson') : null}
            </OrderPageTypography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default SwitchUiObject;
